export const paymentStatus = {
  PAID: 'Paid',
  NOTPAID: 'NotPaid',
  PARTAILYPAID: 'PartallyPaid'
}
